import { httpClient } from './httpClient';
import type {
  RefillGetParams,
  RefillSubmitPayload,
  RefillsGetResponse,
  RefillsSubmitResponse,
} from '../types/api';

const REFILLS_PATH = '/AccountInfo/Refills';

export async function getRefills(params: RefillGetParams): Promise<RefillsGetResponse> {
  const response = await httpClient.get<RefillsGetResponse>(REFILLS_PATH, { params });
  return response.data;
}

export async function postRefills(payload: RefillSubmitPayload): Promise<RefillsSubmitResponse> {
  const response = await httpClient.post<RefillsSubmitResponse>(REFILLS_PATH, payload);
  return response.data;
}
